import { plainToInstance } from 'class-transformer'

import {
  RequestCancelPaymentPayload,
  RequestCancelPaymentAuth,
  MyTicketDetailDto,
  RequestCancelPaymentPathVar,
  RequestUseMyTicketAuth,
  RequestUseMyTicketPayload,
  GetMyTicketDetailPathVar,
  GetMyTicketDetailAuth,
  ShareRequestCancelPaymentPayload,
  UseMyTicketResDto,
  RequestCancelPaymentResDto,
  RequestUserInputPathVar,
  RequestUserInputPayload,
  RequestUserInputAuth
} from '@/api/client/myTicket/dto/myTicketDto'
import axios from '@/lib/axiosClient'

export const myTicketUrlEndpoint = '/ticket'

/** 제휴주차권 */
/**
 * 내주차권 결제취소요청
 * @pathVar {seq: string}
 * @auth {token: string}
 * @payload {guestCode: string}
 */
export const requestCancelPayment = async (
  pathVar: RequestCancelPaymentPathVar,
  auth: RequestCancelPaymentAuth,
  payload: RequestCancelPaymentPayload
) => {
  const { data } = await axios.post(`${myTicketUrlEndpoint}/payment/${pathVar.seq}/cancel`, payload, {
    headers: { Authorization: `Bearer ${auth.token}` }
  })
  return plainToInstance(RequestCancelPaymentResDto, data)
}
/** 공유주차권 */
/**
 * 내주차권(공유) 결제취소요청
 * @pathVar {seq: string}
 * @auth {token: string}
 * @payload {guestCode: string, reportType: REPORT_TYPE}
 */
export const shareRequestCancelPayment = async (
  pathVar: RequestCancelPaymentPathVar,
  auth: RequestCancelPaymentAuth,
  payload: ShareRequestCancelPaymentPayload
): Promise<RequestCancelPaymentResDto> => {
  const { data } = await axios.post(`${myTicketUrlEndpoint}/payment/share/${pathVar.seq}/cancel`, payload, {
    headers: { Authorization: `Bearer ${auth.token}` }
  })
  return plainToInstance(RequestCancelPaymentResDto, data)
}

/**
 * 내주차권 사용요청
 * @auth {token: string}
 * @payload {guestCode: string, couSeq: number}
 */
export const requestUseMyTicket = async (
  payload: RequestUseMyTicketPayload,
  auth: RequestUseMyTicketAuth
): Promise<UseMyTicketResDto> => {
  const { data } = await axios.post(`${myTicketUrlEndpoint}/my-ticket/use`, payload, {
    headers: { Authorization: `Bearer ${auth.token}` }
  })
  return plainToInstance(UseMyTicketResDto, data)
}

/**
 * 내주차권 상세
 * @auth {token: string}
 * @payload { type: string, seq: string, guestCode: string}
 * @result {MyTicketDetailDto}
 */
export const getMyTicketDetail = async (
  pathVar: GetMyTicketDetailPathVar,
  auth: GetMyTicketDetailAuth
): Promise<MyTicketDetailDto> => {
  const { data } = await axios.get<MyTicketDetailDto>(
    `${myTicketUrlEndpoint}/my-ticket/${pathVar.type}/${pathVar.seq}?guestCode=${pathVar.guestCode}`,
    {
      headers: { Authorization: `Bearer ${auth.token}` }
    }
  )
  return plainToInstance(MyTicketDetailDto, data)
}

/**
 * 내주차권 이용자정보 등록하기
 * @pathVar { type: string, seq: string, guestCode: string}
 * @auth {token: string}
 * @payload {userInputJson: string}
 */
export const requestUserInput = async (
  pathVar: RequestUserInputPathVar,
  token: RequestUserInputAuth['accessToken'],
  payload: RequestUserInputPayload
) => {
  await axios.post(`/ticket/my-ticket/${pathVar.couSeq}/user-input`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  })
}

/**
 * 내주차권 이용자정보 수정하기
 * @pathVar { type: string, seq: string, guestCode: string}
 * @auth {token: string}
 * @payload {userInputJson: string}
 */
export const requestModifyUserInput = async (
  pathVar: RequestUserInputPathVar,
  token: RequestUserInputAuth['accessToken'],
  payload: RequestUserInputPayload
) => {
  await axios.put(`/ticket/my-ticket/${pathVar.couSeq}/user-input`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  })
}
